import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** Sopratitolo: piccolo, spaziato, colore secondario. */
export function Eyebrow({ children, className }: { children: ReactNode; className?: string }) {
  return <p className={cn('font-body text-xs font-semibold uppercase tracking-[0.2em] text-ink-soft', className)}>{children}</p>
}
